export default {
  login_mfa: {
    title: '@:login.title',
    message: '已向您注册的电话号码下的SMS发送验证码。\n请输入验证码，并按下登录按钮。\n有效期为5分钟。',
    button_submit: '@:login.login',
    button_resend: '重新发送验证码',
    alert_success: '验证码已重新发送。',
    alert_error: '验证码重新发送失败。',
    error: '@:common.error.code_9999',
    no_phone_number_message: '登录用户没有注册电话号码，因此无法执行SMS短信⾝份认证。\n\n请联系您公司的帐户管理员注册您的电话号码。',
  },
}
